(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4235],{

/***/ 7505:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/user",
      function () {
        return __webpack_require__(8962);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 8962:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1163);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(7379);
/* harmony import */ var components_atoms_common_SpinLoading__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5734);
/* harmony import */ var components_layout_Head__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9604);
/* harmony import */ var components_molecules_headers_SignMobileHeader__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(3517);
/* harmony import */ var components_molecules_headers_SignPCHeader__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(9072);
/* harmony import */ var components_molecules_sign_SigninSocial__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(4294);
/* harmony import */ var hooks_common_useStore__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(8004);
/* harmony import */ var cds_icons__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(6643);
/* harmony import */ var cds_styles__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(3887);
/* harmony import */ var api_user__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(6398);
/* harmony import */ var slices_user_thunk__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(9001);
/* harmony import */ var slices_user__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(491);




// components





// hooks

// styles


// 커뮤니티를 위한 작업




function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 128px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 50px 0;\n\n  ",
        " {\n    padding: 100px 0;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  max-width: 530px;\n  padding: 16px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  max-width: 386px;\n  margin: 0 auto;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  position: relative;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 54px;\n  margin: 0 auto 14px;\n  border: 1px solid rgba(0, 0, 0, 0);\n  border-radius: 4px;\n  font-size: 13px;\n  color: ",
        ";\n\n  & svg {\n    position: absolute;\n    left: 4px;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
/**
 * 소셜 로그인 페이지
 */ var LoginPage = function() {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var dispatch = (0,hooks_common_useStore__WEBPACK_IMPORTED_MODULE_8__/* .useDispatch */ .I)();
    var userInfo = (0,hooks_common_useStore__WEBPACK_IMPORTED_MODULE_8__/* .useSelector */ .v)(function(state) {
        return state.user.info;
    });
    /**
   * 토큰 문제가 있는 사용자의 경우 로그아웃 페이지로 이동합니다.
   * 쿠키 삭제 처리가 이루어지며, 로그인 페이지로 이동합니다.
   */ var setLogout = function() {
        if (false) {}
        window.location.href = "".concat("https://www.classu.co.kr", "/modoo/logout");
    };
    /** 로그인 페이지로 이동 */ var onSignup = function() {
        var urlParams = router.query.url;
        var _query = router.query, url = _query.url, otherParams = _objectWithoutProperties(_query, [
            "url"
        ]);
        var queryString = Object.keys(otherParams).map(function(key) {
            return "&".concat(key, "=").concat(encodeURIComponent(otherParams[key]));
        }).join('');
        var signinUrl = urlParams ? "/user/signin?url=".concat(urlParams).concat(queryString) : "/user/signin";
        router.push(signinUrl);
    };
    /** 유저 정보가 있으면 이전 페이지로 이동한다.*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (!userInfo.isLoaded || !userInfo.id) {
            return;
        }
        // router.isReady()
        // URL 쿼리 파라미터 여부에 따른 페이지 이동 처리
        var urlParams = router.query.url;
        // console.log('urlParams = ', urlParams);
        // //token
        // if (urlParams.includes('community')) {
        //   let token; // 토큰 선언
        //   getToken()
        //     .then(async res => {
        //       token = res.token;
        //       if (!token) {
        //         return;
        //       }
        //       window.localStorage.removeItem('token');
        //       window.localStorage.removeItem('user_id');
        //       window.localStorage.setItem('token', token);
        //       window.localStorage.setItem('user_id', userInfo.id);
        //       console.log('Token:', token); // 콘솔 로그 추가
        //       console.log('user_id:', userInfo.id); // 콘솔 로그 추가
        //       //   (async () => {
        //       //     const res = await dispatch(getUserData());
        //       //     if (res.payload === 470) {
        //       //       setLogout();
        //       //     }
        //       //   })();
        //       // })
        //       return dispatch(getUserData()).then(res => {
        //         if (res.payload === 470) {
        //           setLogout();
        //         }
        //       });
        //     })
        //     .then(() => {
        //       console.log('Redirect URL:', absoluteUrl); // 콘솔 로그 추가
        //       const redirectUrl = urlParams + '&token=' + token;
        //       const absoluteUrl = 'https://dev-home.classu.co.kr/auth/route?urlrow=' + redirectUrl;
        //       router.replace(absoluteUrl);
        //     })
        //     .catch(() =>
        //       dispatch(
        //         updateInfo({
        //           isLoaded: true,
        //         }),
        //       ),
        //     );
        // }
        //
        var redirectUrl = urlParams ? urlParams === '/new' ? '/' : urlParams : "/user/".concat(userInfo.id);
        router.replace(redirectUrl);
    }, [
        router,
        userInfo,
        dispatch
    ]);
    /** 폰 가입 페이지로 이동 */ var onSignBizEmail = function() {
        var urlParams = router.query.url;
        var _query = router.query, url = _query.url, otherParams = _objectWithoutProperties(_query, [
            "url"
        ]);
        var queryString = Object.keys(otherParams).map(function(key) {
            return "&".concat(key, "=").concat(encodeURIComponent(otherParams[key]));
        }).join('');
        var signupUrl = urlParams ? "/user/biz/signin/email?url=".concat(urlParams).concat(queryString) : "/user/biz/signin/email";
        router.push(signupUrl);
    };
    if (!userInfo.isLoaded || userInfo.id) {
        return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(LoadingLayout, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_atoms_common_SpinLoading__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {})
        }));
    }
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_layout_Head__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                mobile: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_molecules_headers_SignMobileHeader__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {}),
                pc: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_molecules_headers_SignPCHeader__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {})
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Main, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Section, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Inner, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_molecules_sign_SigninSocial__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                onSignup: onSignup,
                                onSignBizEmail: onSignBizEmail
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {})
                        ]
                    })
                })
            })
        ]
    }));
};
var LoadingLayout = styled_components__WEBPACK_IMPORTED_MODULE_14__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-6a7725de-0"
})(_templateObject());
var Main = styled_components__WEBPACK_IMPORTED_MODULE_14__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-6a7725de-1"
})(_templateObject1(), cds_styles__WEBPACK_IMPORTED_MODULE_10__/* .mediaQuery.large */ .cy.large);
var Section = styled_components__WEBPACK_IMPORTED_MODULE_14__/* ["default"].section.withConfig */ .ZP.section.withConfig({
    componentId: "sc-6a7725de-2"
})(_templateObject2());
var Inner = styled_components__WEBPACK_IMPORTED_MODULE_14__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-6a7725de-3"
})(_templateObject3());
var LoginButton = styled_components__WEBPACK_IMPORTED_MODULE_14__/* ["default"].button.withConfig */ .ZP.button.withConfig({
    componentId: "sc-6a7725de-4"
})(_templateObject4(), cds_styles__WEBPACK_IMPORTED_MODULE_10__/* .palette.white */ .DG.white);
/* harmony default export */ __webpack_exports__["default"] = (LoginPage);


/***/ }),

/***/ 4294:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(7379);
/* harmony import */ var hooks_domain_review_useRedirectUrl__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3225);
/* harmony import */ var lib_utils_helper__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4058);
/* harmony import */ var cds_icons__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6643);
/* harmony import */ var cds_styles__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3887);



// hooks


// styles


function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  max-width: 530px;\n  padding: 16px;\n  margin: 0 auto;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  max-width: 386px;\n  margin: 0 auto;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  margin-bottom: 50px;\n  font-size: 21px;\n  font-weight: 700;\n  line-height: 34px;\n  text-align: center;\n  color: ",
        ";\n  ",
        " {\n    font-size: 24px;\n    line-height: 42px;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  position: relative;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 54px;\n  margin: 0 auto 14px;\n  border: 1px solid rgba(0, 0, 0, 0);\n  border-radius: 200px;\n  font-size: 13px;\n  color: ",
        ";\n\n  & svg {\n    position: absolute;\n    left: 20px;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  background-color: #fae248;\n  color: ",
        ";\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  background-color: #5cc33a;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  border: 1px solid ",
        ";\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n  background-color: #3a589e;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n  background-color: ",
        ";\n  color: ",
        ";\n  & svg {\n    position: absolute;\n    left: 24px;\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n  background-color: ",
        ";\n  color: ",
        ";\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
var SignInSocial = function(param1) {
    var onSignup = param1.onSignup, onSignBizEmail = param1.onSignBizEmail;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(''), queryParams = ref[0], setQueryParams = ref[1];
    var redirectUrl = (0,hooks_domain_review_useRedirectUrl__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)().redirectUrl;
    /**
   * 소셜 로그인 분기
   * @param {object} params
   * @param {'kakao' | 'facebook' | 'naver' | 'apple'} params.type
   */ var onSocialLogin = function(param) {
        var type = param.type;
        var url = queryParams.slice(5);
        var isFullUrl = url.includes('http');
        var newURL = isFullUrl ? url : "https://www.classu.co.kr".concat(url);
        var prefixURL = window.location.origin;
        var removePrefix = prefixURL + '/';
        var _url = new URL(prefixURL + queryParams);
        _url.searchParams.delete('url');
        _url.searchParams.append('url', newURL);
        var newQueryParams = decodeURIComponent(_url.toString()).replace(removePrefix, '');
        window.open("/modoo/auth/".concat(type).concat(newQueryParams), "signinWin", "width=445,height=550,toolbar=0,scrollbars=0,status=0,resizable=0,location=0,menuBar=0,left=50,top=100");
    };
    /** 리턴 url 설정 */ (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (!(0,lib_utils_helper__WEBPACK_IMPORTED_MODULE_5__/* .isExistWindow */ .br)()) {
            return;
        }
        var params = window.location.search;
        if (params) {
            setQueryParams(params);
            return;
        }
        if (redirectUrl === '/new/user') {
            return;
        }
        setQueryParams("?url=".concat(redirectUrl));
    }, [
        redirectUrl
    ]);
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Section, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Inner, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Title, {
                        children: "지금 바로 시작하기"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(KakaoButton, {
                        onClick: function() {
                            return onSocialLogin({
                                type: 'kakao'
                            });
                        },
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(cds_icons__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                name: "ico_kakao",
                                width: 36,
                                height: 36
                            }),
                            "카카오로 시작하기"
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(NaverButton, {
                        onClick: function() {
                            return onSocialLogin({
                                type: 'naver'
                            });
                        },
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(cds_icons__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                name: "ico_naver",
                                width: 36,
                                height: 36
                            }),
                            "네이버로 시작하기"
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(AppleButton, {
                        onClick: function() {
                            return onSocialLogin({
                                type: 'apple'
                            });
                        },
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(cds_icons__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                name: "ico_apple",
                                width: 36,
                                height: 36
                            }),
                            "애플로 시작하기"
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(FacebookButton, {
                        onClick: function() {
                            return onSocialLogin({
                                type: 'facebook'
                            });
                        },
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(cds_icons__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                name: "ico_meta",
                                width: 30,
                                height: 16
                            }),
                            "메타로 시작하기"
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(PhoneButton, {
                        onClick: onSignup,
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(cds_icons__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                name: "ico_phone_2",
                                width: 20,
                                height: 24
                            }),
                            "휴대폰 번호"
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(BizEmailButton, {
                        onClick: onSignBizEmail,
                        children: "Biz 회원 로그인"
                    })
                ]
            })
        })
    }));
};
var Section = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].section.withConfig */ .ZP.section.withConfig({
    componentId: "sc-a8a5d16f-0"
})(_templateObject());
var Inner = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-a8a5d16f-1"
})(_templateObject1());
var Title = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].h2.withConfig */ .ZP.h2.withConfig({
    componentId: "sc-a8a5d16f-2"
})(_templateObject2(), cds_styles__WEBPACK_IMPORTED_MODULE_4__/* .palette.grey75 */ .DG.grey75, cds_styles__WEBPACK_IMPORTED_MODULE_4__/* .mediaQuery.large */ .cy.large);
var LoginButton = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].button.withConfig */ .ZP.button.withConfig({
    componentId: "sc-a8a5d16f-3"
})(_templateObject3(), cds_styles__WEBPACK_IMPORTED_MODULE_4__/* .palette.white */ .DG.white);
var KakaoButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(LoginButton).withConfig({
    componentId: "sc-a8a5d16f-4"
})(_templateObject4(), cds_styles__WEBPACK_IMPORTED_MODULE_4__/* .palette.black */ .DG.black);
var NaverButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(LoginButton).withConfig({
    componentId: "sc-a8a5d16f-5"
})(_templateObject5());
var AppleButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(LoginButton).withConfig({
    componentId: "sc-a8a5d16f-6"
})(_templateObject6(), cds_styles__WEBPACK_IMPORTED_MODULE_4__/* .palette.grey0 */ .DG.grey0);
var FacebookButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(LoginButton).withConfig({
    componentId: "sc-a8a5d16f-7"
})(_templateObject7());
var PhoneButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(LoginButton).withConfig({
    componentId: "sc-a8a5d16f-8"
})(_templateObject8(), cds_styles__WEBPACK_IMPORTED_MODULE_4__/* .palette.grey75 */ .DG.grey75, cds_styles__WEBPACK_IMPORTED_MODULE_4__/* .palette.black */ .DG.black);
var BizEmailButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(LoginButton).withConfig({
    componentId: "sc-a8a5d16f-9"
})(_templateObject9(), cds_styles__WEBPACK_IMPORTED_MODULE_4__/* .palette.grey0 */ .DG.grey0, cds_styles__WEBPACK_IMPORTED_MODULE_4__/* .palette.grey75 */ .DG.grey75);
/* harmony default export */ __webpack_exports__["Z"] = (SignInSocial);


/***/ }),

/***/ 3225:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1163);
/* harmony import */ var lib_utils_deviceChecker__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7496);


// utils

/**
 * 비로그인시 redirect url을 설정한다.
 *
 * @example
 * const { redirectUrl, setRedirectUrl } = useRedirectUrl();
 * ${process.env.NEXT_PUBLIC_DEFAULT_HOST}/modoo/storeLogin?url=${redirectUrl};
 * setRedirectUrl({type: ...});
 */ var useRedirectUrl = function() {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    var classId = router.query.classId;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(''), url = ref[0], setUrl = ref[1];
    /**
   * 로컬스토리지에 redirect type을 저장한다.
   * @param {object} props
   * @param {'share' | 'payment' | string} props.type
   */ var setRedirectUrl = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(param) {
        var type = param.type;
        var device = (0,lib_utils_deviceChecker__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
        if (!device.app()) {
            window.localStorage.removeItem('redirectType');
            window.localStorage.setItem('redirectType', type);
        }
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var device = (0,lib_utils_deviceChecker__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
        if (device.app()) {
            return;
        }
        var redirectType = window.localStorage.getItem('redirectType');
        if (!redirectType) {
            return;
        }
        if (redirectType === 'share') {
            return setUrl(window.location.pathname);
        }
        if (redirectType === 'payment') {
            return setUrl("/class/pay/payinfo/".concat(classId));
        }
        if (redirectType === 'reload') {
            return setUrl(window.location.pathname);
        }
        if (/^https?/i.test(redirectType)) {
            return setUrl(redirectType);
        }
    }, [
        router,
        classId,
        setRedirectUrl
    ]);
    return {
        setRedirectUrl: setRedirectUrl,
        redirectUrl: url
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useRedirectUrl);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [8947,9774,2888,179], function() { return __webpack_exec__(7505); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);